@if (order$ | async; as order) {
  <div class="cx-order-summary">
    <div class="container">
      <!-- Order Info -->
      <div class="cx-summary-card">
        @if (order.purchaseOrderNumber || order.purchaseOrderNumber === '') {
          <cx-card  [content]="getPurchaseOrderNumber(order?.purchaseOrderNumber) | async"></cx-card>
        }
        <cx-card [content]="getOrderCurrentDateCardContent(knBrDateHelper.formatDisplayDate(date)) | async"></cx-card>
        <cx-card [content]="getOrderStatusCardContent(order?.statusDisplay) | async"></cx-card>
      </div>
      <!-- Purchase Order / Payment Info -->
      <!-- <ng-container *ngIf="order.purchaseOrderNumber || order.purchaseOrderNumber === ''">
      <div class="cx-summary-card">
        <cx-card [content]="getPurchaseOrderNumber(order?.purchaseOrderNumber) | async"></cx-card>
        <cx-card [content]="getMethodPaymentCardContent(order?.paymentInfo) | async"></cx-card>
        <cx-card
          *ngIf="order?.step2customerName"
          [content]="{ title: 'checkoutOrderConfirmation.contractor' | cxTranslate, text: [order?.step2customerName] }"
        ></cx-card>
      </div>
    </ng-container> -->
    <!-- Delivery Info -->
    <div class="cx-summary-card address-card">
      @if (order.deliveryAddress) {
        <cx-card [content]="getAddressCardContent(order?.deliveryAddress) | async"></cx-card>
      }
      @if (order.deliveryMode) {
        <cx-card [content]="getDeliveryModeCardContent(order) | async"></cx-card>
      }
    </div>
    <!-- Payment Info -->
    <!-- <ng-container *ngIf="order.paymentInfo">
    <div class="cx-summary-card">
      <cx-card [content]="getPaymentInfoCardContent(order?.paymentInfo) | async"></cx-card>
      <cx-card [content]="getBillingAddressCardContent(order?.paymentInfo?.billingAddress) | async"></cx-card>
    </div>
  </ng-container> -->
  <!-- Totals -->
  <div class="cx-summary-card">    
      @if (order.totalItems) {
        <cx-card [content]="getTotalItems(order?.totalItems) | async"></cx-card>
      }
      @if (order.totalUnitCount) {
        <cx-card [content]="getTotalQuantity(order?.totalUnitCount) | async"></cx-card>
      }
      @if (!(hidePricing$ | async)) {
        @if (order.totalPrice) {
          <cx-card [content]="getOrderTotal(order?.totalPrice?.formattedValue) | async"></cx-card>
        }
      }
    @if (order?.headerComments) {
      <cx-card [content]="getOrderSpecialInstructions(order?.headerComments) | async"></cx-card>
    }
  </div>
</div>
</div>
}